
import AudioPlayer from "../../engine/audio/audioPlayer";
import AudioAnalyser from "../../engine/audio/audioAnalyser";
import Entity from "../../engine/entity";

export default class MusicManager extends Entity{
    constructor({engine, tracklist}){
        super({engine, type:"music"});
        this.audioPlayer = new AudioPlayer({tracklist});
        this.audioPlayer.autoPlaylist = false;
        this.analyser = new AudioAnalyser({audio: this.audioPlayer, fftSize: 256});
        this.analyser.debugger.on=false;
        this.effectMult = 1;
    }

    update(){
        this.analyser.refreshData(this.engine.time.time);
    }

    render(){
        this.analyser.debug();
        this.engine.renderer.passes[0].material.uniforms.music_intensity.value = this.analyser.data.intensity * this.effectMult;
        this.engine.renderer.passes[1].material.uniforms.music_volume.value = Math.pow(this.analyser.data.rawvolume,2) * this.effectMult;
    }

    stop(){
        this.audioPlayer.pause();
    }
}